export const HIGHLIGHT_GGLOCATION = 'HIGHLIGHT_GGLOCATION';

export const highlightGglocation = ({ id }) => ({
  type: HIGHLIGHT_GGLOCATION,
  id,
});
